var map = {
	"./beige-ribbon.svg": "95d2",
	"./black-ribbon.svg": "3514",
	"./blue-ribbon.svg": "e528",
	"./green-ribbon.svg": "e80d",
	"./lightgreen-ribbon.svg": "2995",
	"./navy-ribbon.svg": "3ff7",
	"./orange-ribbon.svg": "a162",
	"./pink-ribbon.svg": "c6d0",
	"./purple-ribbon.svg": "1d61",
	"./red-ribbon.svg": "54c8",
	"./royalblue-ribbon.svg": "d5ad",
	"./teal-ribbon.svg": "17b3",
	"./white-ribbon.svg": "0b11",
	"./yellow-ribbon.svg": "6479"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";